const SuperAdminMenuList = [
  {
    name: "Dashboard",
    path: "dashboard",
    icon: "home",
  },
  {
    name: "Customer Managment",
    path: "customer",
    icon: "user",
  },
  {
    name: "Service Management",
    path: "service",
    icon: "truck",
  },
  {
    name: "Orders Management",
    path: "orders",
    icon: "gift",
  },{
    name: "Udhar Management",
    path: "udhar",
    icon: "wallet",
  },{
    name: "Downloads",
    path: "download",
    icon: "download",
  },
];

export default SuperAdminMenuList;
